.advancedSearchButton {
  flex: 0 0 145px;
  margin-right: 10px !important;
  border-radius: 8px !important;
}
